module.exports = __webpack_public_path__ + "static/img/zx.2ebc0791.png";